
const initialState = {
  data: undefined,
  filterData: undefined,
  selectedData: undefined,
  check: undefined,
  param: undefined,
  getData: undefined,
  setControl: undefined
};

const CreateReducer = (REDUCER, INITIAL_STATE?) => {
  const { set, clear } = REDUCER
  return (state = INITIAL_STATE ? INITIAL_STATE : initialState, action) => {
    switch (action.type) {
      case set:
        return action.payload
      case clear:
        return INITIAL_STATE ? INITIAL_STATE : initialState
      default:
        return state
    }
  }
}

export const CreateBooleanReducer = (TRUE_ACTION, FALSE_ACTION, INITIAL_STATE?) => {
  return (state = INITIAL_STATE ? INITIAL_STATE : false, action) => {
    switch (action.type) {
      case TRUE_ACTION:
        return true
      case FALSE_ACTION:
        return false
      default:
        return state
    }
  }
}

export default CreateReducer